import { useEffect, useState } from 'react';

export function useCurrentTime(): Date {
    const [now, setNow] = useState(() => new Date());

    useEffect(() => {
        const id = window.setInterval(() => setNow(new Date()), 1_000);
        return () => window.clearInterval(id);
    }, []);

    return now;
}
